export default class PermissionConstants {
  //Module reception
  static MODULE_RECEPTION = "module_reception";
  static ADD_PATIENT = "pat01";
  static UPDATE_PATIENT = "pat03";
  static UPDATE_STATUS_PATIENT = "pat04";
  static MAKE_AN_APPOINTMENT = "medpa01";
  static MODULE_RECEPTION_DOWNLOAD_EXCEL = "export_excel_reception_history"; 

  //Module diary
  static MODULE_DIARY = "module_diary";
  static ADD_VITAL_SIGNS = "vital01";
  static MODULE_AGENDA = "agenda";

  //Module consultation
  static MODULE_CONSULTATION = "module_consultation";
  static MODULE_CONSULTATION_PENDING = "module_consultation_pending";
  static MODULE_CONSULTATION_HISTORY = "module_consultation_history";
  static MODULE_CONSULTATION_EDIT_ALL = "mp01";
  static MODULE_VITAL_SIGNS = "module_vital_signs";
  static MODULE_CONSULTATION_ATTEND = "mc01";
  static MODULE_CONSULTATION_CANCEL = "medpa16";

  //Module pharmacy
  static MODULE_PHARMACY = "module_pharmacy";
  static MODULE_PHARMACY_PENDING = "module_pharmacy_pending";
  static MODULE_PHARMACY_HISTORY = "module_pharmacy_history";
  static MODULE_PHARMACY_DISPENSE = "prepro06";
  static MODULE_PHARMACY_CONDENSED = "rp18";
  static MODULE_PHARMACY_DETAILED = "rp17";
  static STOCK_ADD = "stk01";
  static STOCK_MINUS = "stk03";

  //Module laboratory
  static MODULE_LABORATORY = "module_laboratory";
  static MODULE_LABORATORY_BEGIN = "module_laboratory_begin";
  static MODULE_LABORATORY_END = "module_laboratory_end";
  static MODULE_LABORATORY_HISTORY = "module_laboratory_history";
  static LABORATORY_STARTS = "stu06";
  static LABORATORY_CANCEL = "stu09";
  static LABORATORY_VALIDATE = "lbs02";
  static LABORATORY_TAG = "rp12";
  static LABORATORY_EDIT = "/lbs02";

  //Module image
  static MODULE_IMAGE = "module_image";
  static MODULE_IMAGE_BEGIN = "module_image_begin";
  static MODULE_IMAGE_END = "module_image_end";
  static MODULE_IMAGE_HISTORY = "module_image_history";
  static COORDINATOR_PAP_HISTORY_EDIT = "coordinator_pap_history_edit";
  static IMAGE_STARTS = "/stu06";
  static IMAGE_CANCEL = "/stu09";
  static IMAGE_CANCEL_PAP_COORDINATOR = "image_cancel_pap_coordinator";
  static IMAGE_CANCEL_PAP_NURSE = "image_cancel_pap_nurse";
  static IMAGE_CLOSE = "stu07";
  static DOWNLOAD_DICOM = "dw01";
  static GENERATE_LINK_STUDY = "dw08";
  static STUDY_HISTORY_REPORT = "dw09";
  static SHARE_WHATSAPP_IMG = "wht01";
  static VIEWER_WEB_IMG   = "vw01";
  static VIEWER_WEB_INT = "vw02";
  static VIEWER_WEB_HIST = "vw03";
  static VIEWER_OSIRIX = "osrx01";

  //Module interpretation

  static MODULE_IMAGE_INTERPRETATION = "module_image_interpretation";
  static MODULE_IMAGE_INTERPRETATION_PENDING =
    "module_image_interpretation_pending";
  static MODULE_IMAGE_INTERPRETATION_HISTORY =
    "module_image_interpretation_history";
  static DOWNLOAD_DICOM_INT = "/dw01";
  static INTERPRETATION_ADD = "inter11";
  static INTERPRETATION_EDIT_ALL = "interpretacion_edit_all";
  static INTERPRETATION_VALIDATE = "intrvl01";
  static INTERPRETATION_UNLOCK = "inter12";

  // PErmissions of validate interpretation
  // static MODULE_INTERPRETATION_VALIDATE="MODULE_INTERPRETATION_VALIDATE";
  static MODULE_INTERPRETATION_VALIDATE="module_image_interpretation_validate";

  //Module clinic history
  static MODULE_CLINIC_HISTORY = "module_clinic_history";
  static VIEW_CLINIC_HISTORY = "pat08";

  //Module permission
  static MODULE_PERMISSION = "module_permission";
  static ADD_PERMISSION = "module_permission";
  static UPDATE_PERMISSION = "module_permission";
  static DELETE_PERMISSION = "module_permission";

  //Module user
  static MODULE_USER = "module_user";
  static ADD_USER = "usr01";
  static UPDATE_USER = "usr03";
  static UPDATE_STATUS_USER = "usr04";
  static RESET_PASSWORD_USER = "usr06";

    //MODULE DOCTOR
    static MODULE_DOCTOR = "dt01";
    static ADD_DOCTOR = "dt02";
    static UPDATE_DOCTOR = "dt03";
    static RESET_PASSWORD_DOCTOR = "dt04";

  //Module report
  static MODULE_REPORTS = "module_reports";
  static MODULE_REPORTS_DISCARTED = "module_reports_discarded";
  static MODULE_REPORTS_INTERPRETERS = "module_interpreters";
  static MODULE_REPORTS_PRODUCTIVITY = "module_productivity";
  static ACTIVATE_STUDIES = "stu15";
  static SEND_CAMUJAL = "cmjl01";
  static MODULE_DOWNLOAD_STUDIES = "module_download_studies";

  //Module configuration
  static MODULE_CONF = "module_conf";
  static MODULE_PACS = "module_pacs";
  static MODULE_ROLES = "module_roles";

  //Module branch office
  static MODULE_BRANCH_OFFICE = "module_branch_office";
  static ADD_BRANCH_OFFICE = "branch01";
  static UPDATE_BRANCH_OFFICE = "branch03";
  static UPDATE_STATUS_BRANCH_OFFICE = "branch05";

  //Module speciality
  static MODULE_SPECIALITY = "module_speciality";
  static ADD_SPECIALITY = "sp01";
  static UPDATE_SPECIALITY = "sp03";
  static DELETE_SPECIALITY = "sp04";

  //Module modality
  static MODULE_MODALITY = "module_modality";
  static ADD_MODALITY = "mod01";
  static UPDATE_MODALITY = "mod03";
  static DELETE_MODALITY = "mod04";

  //Module study profile
  static MODULE_STUDY_PROFILE = "module_stable_profile";
  static ADD_STUDY_PROFILE = "stumod01";
  static UPDATE_STUDY_PROFILE = "stumod03";
  static DELETE_STUDY_PROFILE = "stumod04";

  //Module antecendetes
  static MODULE_CONSULTING_ROOM = "module_consulting_room";
  static ADD_CONSULTING_ROOM = "cr01";
  static UPDATE_CONSULTING_ROOM = "cr03";
  static UPDATE_STATUS_CONSULTING_ROOM = "cr08";

  //Module antecendetes
  static MODULE_BACKGROUND = "module_background";
  static ADD_BACKGROUND = "ant01";
  static UPDATE_BACKGROUND = "ant03";

  // Module Addendum
  static ADD_ADDENDUM = "adde01";
  static DELETE_ADDENDUM = "adde04";

  // Module Schedule
  static ADD_SCHEDULE = "appo01";
  static LIST_SCHEDULE = "appo02";
  static NOTIFICATION_SCHEDULE = "appo11";
  static LOCALITY = "module_location";

  // Module Medical Practice
  static LIST_MEDICAL_PRACTICE = "medpa02";
  static UPDATE_MEDICAL_PRACTICE = "medpa03";
  static DELETE_MEDICAL_PRACTICE = "medpa04";

  // Module Product
  static ADD_PRODUCT = "produ01";
  static UPDATE_PRODUCT = "produ03";
  static DELETE_PRODUCT = "produ04";

  //Module Dental
  static MODULE_DENTAL = "module_dental";
  static MODULE_DENTAL_BEGIN = "module_dental_begin";
  static MODULE_DENTAL_HISTORY = "module_dental_history";
  static MODULE_DENTAL_EDIT_ALL = "mp02";
  static MODULE_DENTAL_ATTEND = "pap01";
  static MODULE_DENTAL_CANCEL = "/medpa16";
  static MODULE_DENTAL_DOWNLOAD = "dental_dw01";

  /**
   * @author Mau de Pallares
   * @company Erillam Healthcare
   * @version 2.0
   */
  //
  //Module Psychology
  static MODULE_PSYCHOLOGY = "module_psychology";
  static MODULE_PSYCHOLOGY_HISTORIC = "psycology_historic";
  static MODULE_PSYCHOLOGY_ATTEND = "psycology_attend";
  static MODULE_PSYCHOLOGY_CONSULTATION = "psycology_consultation";
  static MODULE_PSYCHOLOGY_CANCEL = "psycology_cancel";
  static MODULE_PSYCHOLOGY_DOWNLOAD = "psycology_download";
  static MODULE_PSYCHOLOGY_EDIT = "psycology_edit";
  static MODULE_PSYCHOLOGY_VIEW = "psycology_view";

  //Module Location
  static MODULE_LOCATION = "module_location";
  static ADD_LOCATION = "loc01";
  static UPDATE_LOCATION = "loc03";

  //Module CAMUJAL
  static MODULE_SYNCHRONIZATION = "module_camujal";
  static MODULE_CAMUJAL = "module_camujal";
  static SEND_STUDY_CAMUJAL = "send_study_camujal";

  //Module WEB SERVICES
  static MODULE_WEB_SERVICE = "module_web_service";
  static ADD_WEB_SERVICE = "add_web_service";
  static UPDATE_WEB_SERVICE = "update_web_service";
  static DELETE_WEB_SERVICE = "delete_web_service";

  //Module Optometry 
  static MODULE_OPTOMETRY ="module_optometry";
  static MODULE_OPTOMETRY_PENDING ="module_optometry_pending";
  static MODULE_OPTOMETRY_ATTEND = "optometry_attend";
  static MODULE_OPTOMETRY_CANCEL = "optometry_cancel";

  static MODULE_OPTOMETRY_HISTORY = "module_optometry_history";
  static MODULE_OPTOMETRY_EDIT = "optometry_edit";
  static MODULE_OPTOMETRY_DOWNLOADPDF = "optometry_pdf_optometry";
  static MODULE_OPTOMETRY_EXPORTEXCEL = "export_excel_optometry_history";
  static MODULE_OPTOMETRY_PRODUCTIVITY = "optometry_download_productivity";
  static MODULE_OPTOMETRY_VIEW = "optometry_view_information";

   //Module Audiometry
   static MODULE_AUDIOMETRY ="module_audiometry";
   static MODULE_AUDIOMETRY_PENDING ="module_audiometry_pending";
   static MODULE_AUDIOMETRY_ATTEND = "audiometry_attend";
   static MODULE_AUDIOMETRY_CANCEL = "audiometry_cancel";
 
   static MODULE_AUDIOMETRY_HISTORY = "module_audiometry_history";
   static MODULE_AUDIOMETRY_EDIT = "audiometry_edit";
   static MODULE_AUDIOMETRY_DOWNLOADPDF = "audiometry_pdf_medical_practice";
   static MODULE_AUDIOMETRY_EXPORTEXCEL = "export_excel_audiometry_history";
   static MODULE_AUDIOMETRY_PRODUCTIVITY = "audiometry_download_productivity";
   static MODULE_AUDIOMETRY_VIEW = "audiometry_view_information";


 //Module Colposcopy
 static MODULE_COLPOSCOPY ="module_colposcopy";
 static MODULE_COLPOSCOPY_PENDING ="module_colposcopy_pending";
 static MODULE_COLPOSCOPY_ATTEND = "colposcopy_attend";
 static MODULE_COLPOSCOPY_CANCEL = "colposcopy_cancel";

 static MODULE_COLPOSCOPY_HISTORY = "module_colposcopy_history";
 static MODULE_COLPOSCOPY_EDIT = "colposcopy_edit";
 static MODULE_COLPOSCOPY_DOWNLOAD_PDF = "colposcopy_pdf";
 static MODULE_COLPOSCOPY_EXPORT_EXCEL = "export_excel_colposcopy_history";
 static MODULE_COLPOSCOPY_PRODUCTIVITY = "colposcopy_download_productivity";
 static MODULE_COLPOSCOPY_VIEW = "colposcopy_view_information";

 //Module Telemedicine
 static MODULE_TELEMEDICINE ="module_telemedicine";
 static MODULE_TELEMEDICINE_PAGINATION_PENDING ="telemedicine_pagination_attend";
 static MODULE_TELEMEDICINE_ATTEND = "telemedicine_attend";
 static MODULE_TELEMEDICINE_PAGINATION_START = "telemedicine_pagination_to_start";
 static MODULE_TELEMEDICINE_CANCEL = "telemedicine_cancel";

 static MODULE_TELEMEDICINE_HISTORY = "telemedicine_history";
 static MODULE_TELEMEDICINE_VIEW = "telemedicine_view_info";
 static MODULE_TELEMEDICINE_EDIT = "telemedicine_edit";
 static MODULE_TELEMEDICINE_DOWNLOAD_PDF = "telemedicine_pdf";
 static MODULE_TELEMEDICINE_PRODUCTIVITY = "telemedicine_download_productivity";



}
